// Same situation as AddProgramItemToCartModal/formConfig/index.js: this
// file has been empty since the initial new-code/ import (4ec4ff6), but
// index.js (`demoSchema`) and components/ParentChildForm/index.js
// (`getTransformErrors`) still import from it. CRA's webpack returned
// `undefined` at module load and the runtime crashed only when the form
// opened; Vite's Rollup rejects the build at compile time. Stubs preserve
// the prior runtime behavior — `transformErrors={undefined}` and
// `schema={{}}` both mean "use rjsf defaults" — without changing anything
// that ran successfully before.
export const getTransformErrors = () => undefined
export const demoSchema = {}
